export default "__VITE_ASSET__85ee2dd3__"